<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content" v-if="usertype == 'zonal-manager'">
			<br>
			<!-- main row for all icons  -->
			<div class="col-md-12">
				<div class="card card-primary card-outline">
					<div class="card-body">
						<div class="col-md-12" v-for="(item, index) in stocktransfer.stock_transfer_request_details">
							<div class="row">
								<div class="col-md-9">
									item, Required: {{item.required_quantity}}, Approved: {{item.approved_quantity}}, status: {{item.status}}
								</div>
								<div class="col-md-3 center center-block" align="center">
									<div class="row">
										<div class="col-md-3">
											<button class="btn btn-success fa fa-plus" @click="increment(index)"></button>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<input type="number" min="1" v-model="stocktransfer.stock_transfer_request_details[index].approved_quantity" style="width: 100%;">
											</div>
										</div>
										<div class="col-md-3">
											<button class="btn btn-danger fa fa-minus" @click="decrement(index)"></button>
										</div>
									</div>
									<button class="btn btn-success" @click="approveItemZM(index, 'APPROVED')" v-if="item.status == 'CREATED'">Approve</button>
									<button class="btn btn-danger" @click="approveItemZM(index, 'REJECTED')" v-if="item.status == 'CREATED'">Reject</button>
								</div>
								<div class="col-md-2">
									<input type="text" v-model="stocktransfer.stock_transfer_request_details[index].Notes" placeholder="Enter notes">
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<input type="text" v-model="notes" placeholder="Enter notes">
							<!--<div class="form-group">
						  	<label>Delivery Partner</label>
						  	<v-select v-model="dp_id" :options="deliverypartners" label="name" :reduce="deliverypartners => deliverypartners.id" @input="getRest"></v-select>
						  </div>
						  <div class="form-group">
						  	<label>Driver</label>
						  	<select class="form-control" v-model="driver_id">
						  		<option v-for="driver in drivers" :value="driver.id">{{driver.lead_profile.name}}</option>
						  	</select>  
						  </div>
						  <div class="form-group">
						  	<label>Vehicle</label>
						  	<select class="form-control" v-model="vehicle_id">
						  		<option v-for="vehicle in vehicles" :value="vehicle.id">{{vehicle.make}}, {{vehicle.model}}, {{vehicle.color}}, {{vehicle.reg_no}}</option>
						  	</select>  
						  </div>
						  <div class="form-group">
						  	<label>Transport Mode</label>
						  	<select class="form-control" v-model="mode">
						  		<option v-for="m in modes" :value="m.code">{{m.mode}}</option>
						  	</select>  
						  </div>
						  <div class="form-group">
						  	<label>Distance</label>
						  	<input type="number" v-model="distance" placeholder="Enter the distance" class="form-control" min="0" step=".01">
						  </div>-->
						</div>
						<div class="col-md-6">
							<button class="btn btn-danger" @click="approveTransfer">Approve Stock Transfer</button>
						</div>
					</div>
				</div>
			</div>
    </section>
    
    <section class="content" v-if="usertype == 'branch-manager'">
			<br>
			<!-- main row for all icons  -->
			<div class="col-md-12">
				<div class="card card-primary card-outline">
					<div class="card-body">
						<div class="col-md-12" v-for="(item, index) in stocktransfer.stock_transfer_request_details">
							<div class="row">
								<div class="col-md-9">
									item, Required: {{item.required_quantity}}, Approved: {{item.approved_quantity}}, Transfer: {{item.transferred_quantity}}
									<br>
									<div class="form-group">
										<label>Serial Numbers: </label>
										<span class="lead">
											<span v-if="stocktransfer.stock_transfer_request_details[index].stock_transfer_items.length>0" v-for="(sl, i) in item.stock_transfer_items" :key="i" class="badge badge-pill badge-dark">
												{{sl.transferred_imei}} 
												<a style="cursor: pointer;" @click="removeSl(index,i)"><i class="fa fa-times" aria-hidden="true"></i></a>
											</span>
										</span>
									</div>
								</div>
								<div class="col-md-3">
									<div class="row">
										<div class="col-md-3">
											<button class="btn btn-success fa fa-plus" @click="increment(index)"></button>
										</div>
										<div class="col-md-2">
											<input type="number" min="1" v-model="stocktransfer.stock_transfer_request_details[index].transferred_quantity">
										</div>
										<div class="col-md-3">
											<button class="btn btn-danger fa fa-minus" @click="decrement(index)"></button>
										</div>
									</div>
									<div class="col-md-6">
										<div class="form-group">
											<input type="text" placeholder="Enter the serial number" v-model="sl_no">
										</div>
										<div class="form-group">
											<button class="btn btn-danger" @click="addSerial(index, item.item_code)">Add</button>
										</div>
									</div>
									<button class="btn btn-success" @click="approveItemBM(index, 'APPROVED')" v-if="item.status == 'CREATED' || item.status == 'APPROVED' ">Approve</button>
									<button class="btn btn-danger" @click="approveItemBM(index, 'REJECTED')" v-if="item.status == 'CREATED' || item.status == 'REJECTED'">Reject</button>
								</div>
								<div class="col-md-2">
									<input type="text" v-model="stocktransfer.stock_transfer_request_details[index].Notes" placeholder="Enter notes">
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<input type="text" v-model="notes" placeholder="Enter notes">
						</div>
						<div class="col-md-6">
							<button class="btn btn-danger" @click="completeTransfer" v-if="stocktransfer.status == 'Pending Branch Manager Approval'">Complete Stock Transfer</button>
						</div>
						<div class="col-md-6">
							<button class="btn btn-danger" @click="receivedTransfer" v-if="stocktransfer.status == 'In Transit'">Received Stock Transfer</button>
						</div>
					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->

<!-- All VUE Parts end before this comment -->
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getStockTransfer();
        	this.usertype = window.user.user_type;
        	this.getDeliveryPartners();
        	this.getModes();
        },
        
        data(){
        	return{
        		stocktransfer: {},
        		usertype: '',
        		notes: '',
        		sl_no: '',
        		deliverypartners: [],
            dp_id: '',
            drivers: [],
            driver_id: '',
            vehicles: [],
            vehicle_id: '',
            distance: '',
            modes: [],
            mode: '',
        	}
        },
        
        methods: {
        	getStockTransfer(){
        		axios.post("/api/getStockTransfer", {id: this.$route.params.id})
        		.then(response => {
        			this.stocktransfer = response.data;
        		})
        	},
        	
        	getDeliveryPartners(){
        		axios.post("/api/getAllDeliveryPartners")
        		.then(response => {
        			this.deliverypartners = response.data;
        		})
        	},
        	
        	getRest(){
        		axios.post("/api/getPartnerDrivers", {dp: this.dp_id, paginate: false})
        		.then(response => {
        			this.drivers = response.data;
        		})
        		axios.post("/api/getPartnerVehicles", {dp: this.dp_id, paginate: false})
        		.then(response => {
        			this.vehicles = response.data;
        		})
        	},
        	
        	getModes(){
        		axios.post("/api/getTMS")
        		.then(response => {
        			this.modes = response.data;
        		})
        	},
        	
        	increment(index){
        		if(this.usertype == 'zonal-manager')
        			this.stocktransfer.stock_transfer_request_details[index].approved_quantity = parseInt(this.stocktransfer.stock_transfer_request_details[index].approved_quantity)+parseInt(1);
        		this.stocktransfer.stock_transfer_request_details[index].transferred_quantity = parseInt(this.stocktransfer.stock_transfer_request_details[index].approved_quantity)+parseInt(1);
        	},
        	
        	decrement(index){
        		if(this.usertype == 'zonal-manager')
        			this.stocktransfer.stock_transfer_request_details[index].approved_quantity = parseInt(this.stocktransfer.stock_transfer_request_details[index].approved_quantity)-parseInt(1);
        		this.stocktransfer.stock_transfer_request_details[index].transferred_quantity = parseInt(this.stocktransfer.stock_transfer_request_details[index].approved_quantity)-parseInt(1);
        	},
        	
        	addPrompt(){
        		$("#searchModal").modal("show");
        	},
        	
        	approveItemZM(index, status){
        		this.stocktransfer.stock_transfer_request_details[index].status = status;
        	},
        	
        	approveItemZM(index, status){
        		this.stocktransfer.stock_transfer_request_details[index].status = status;
        	},
        	
        	approveTransfer(){
        		axios.post("/api/stockTransferAccept", {id: this.stocktransfer.id, items: this.stocktransfer.stock_transfer_request_details, notes: this.notes})
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Request Made'
        			});
        		})
        	},
        	
        	completeTransfer(){
        		axios.post("/api/stockTransferComplete", {id: this.stocktransfer.id, items: this.stocktransfer.stock_transfer_request_details, notes: this.notes})
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Request Complete'
        			});
        		})
        	},
        	
        	addSerial(index, item_code){
        		axios.post("/api/verifySerialNo", {code: item_code, sl_no: this.sl_no, warehouse: this.stocktransfer.destination_warehouse})
        		.then(response =>{
        			if(response.data == 1){
        				this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items.push({transferred_imei: this.sl_no});
        				this.sl_no = '';
        			}
        			else
        				toast.fire({
  								title: 'Wrong Sl. No.',
  								icon: 'success'      				
        				})
        		});
        	},
        	
        	removeSl(index, i){
        		this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items.splice(i, 1);
        	},
        	
        	receivedTransfer(){
        		axios.post("/api/stockTransferReceived", {id: this.stocktransfer.id, items: this.stocktransfer.stock_transfer_request_details, notes: this.notes})
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Request Received'
        			});
        		})
        	},
        }
    }
</script>
